
import { Link } from "react-router-dom";
import { ShieldCheck, AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

export default function AuthNotConfigured() {
  return (
    <div className="max-w-md w-full space-y-8">
      <div>
        <div className="flex justify-center">
          <ShieldCheck className="h-12 w-12 text-fraudeye-accent" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
          Authentication Not Available
        </h2>
      </div>
      
      <Alert variant="destructive" className="mt-6">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle>Supabase Connection Required</AlertTitle>
        <AlertDescription>
          Registration is currently unavailable because Supabase is not properly connected.
        </AlertDescription>
      </Alert>
      
      <div className="mt-6 text-center">
        <p className="mb-4">To enable authentication, follow these steps:</p>
        <ol className="text-left list-decimal pl-5 space-y-2 mb-6">
          <li>Click the green Supabase button in the top right corner</li>
          <li>Select "Connect to Supabase"</li>
          <li>Complete the connection process</li>
          <li>Refresh the page after connection is complete</li>
        </ol>
        
        <div className="space-x-4">
          <Button asChild variant="secondary">
            <Link to="/">Return to Home</Link>
          </Button>
          <Button asChild>
            <a href="https://docs.lovable.dev/integrations/supabase/" target="_blank" rel="noopener noreferrer">
              View Supabase Docs
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
}
